import { Suspense, PropsWithChildren } from 'react';

import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import {
  InitAuth,
  InitFingerprint,
  isFailedToAuthorizeError,
} from '@cast/infrastructure-auth';
import { InitRouter } from '@cast/infrastructure-navigation';
import { ErrorPageGeneric } from 'components/error-pages';
import { SuspenseLoader } from 'components/loaders';
import { redirectToScreen } from 'utils/auth';

import {
  InitOrganization,
  isOrganizationsFetchError,
} from '@cast/infrastructure-organization';

const Fallback = ({ error }: FallbackProps) => {
  if (isOrganizationsFetchError(error)) {
    return <ErrorPageGeneric />;
  }
  if (!isFailedToAuthorizeError(error)) {
    // Unknown error - forward to upper error boundary
    throw error;
  }
  redirectToScreen(window.location.href);
  // Same behavior as it is now. This definitely needs a better UX
  return null;
};

type Props = PropsWithChildren<{
  initAuth?: boolean;
  initOrganization?: boolean;
}>;
export const InitApp = ({ children, initAuth, initOrganization }: Props) => {
  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      <Suspense fallback={<SuspenseLoader />}>
        <InitRouter />
        {initAuth ? (
          <>
            <InitAuth />
            <InitFingerprint />
          </>
        ) : null}
        {initOrganization ? <InitOrganization /> : null}
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};
